import { useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import TransitApiConfig from '../../../TransitOperationEditor/hooks/apiConfig'

const {
  baseUrl,
  queryKeys: {
    rootPath,
  },
} = TransitApiConfig.paths.transitOperation

function useTransitOperationDraftDeletion() {
  const queryClient = useQueryClient()

  const deleteTransitOperationDraft = async (id: number | undefined) => {
    if (id === null || id === undefined) throw new Error('Transit Operation ID cannot be null or undefined!')
    await axios.delete<void>(`${baseUrl}/${id}`)
    await queryClient.invalidateQueries({ queryKey: [rootPath] })
  }

  return {
    deleteTransitOperationDraft,
  } as const
}

export default useTransitOperationDraftDeletion
